
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/quizzes/[...slug]",
      function () {
        return require("private-next-pages/quizzes/[...slug].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/quizzes/[...slug]"])
      });
    }
  